import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = {
    key: 1,
    class: "alert alert--error"
};
import { onMounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import venso from "@/services/VensoRepository";
import VensoInvoiceRequest from "@/components/VensoInvoiceRequest.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoInvoiceRequestView',
    setup(__props) {
        const route = useRoute();
        const invoiceRequestId = ref(route.params.id);
        const accessToken = ref(route.query.token);
        const invoiceRequest = ref(null);
        const error = ref(null);
        onMounted(loadInvoiceRequest);
        watch(invoiceRequestId, loadInvoiceRequest);
        function loadInvoiceRequest() {
            venso.getInvoiceRequest(invoiceRequestId.value, accessToken.value)
                .then(data => invoiceRequest.value = data)
                .catch(e => error.value = e);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !invoiceRequest.value && !error.value
                }, null, 8, ["loading"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (invoiceRequest.value)
                    ? (_openBlock(), _createBlock(VensoInvoiceRequest, {
                        key: 0,
                        invoiceRequest: invoiceRequest.value
                    }, null, 8, ["invoiceRequest"]))
                    : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('venso_order_group.load_error', { error: error.value })), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
